import { render } from "./LabelOrderNewPage.vue?vue&type=template&id=5a0d5111&scoped=true"
import script from "./LabelOrderNewPage.vue?vue&type=script&lang=js"
export * from "./LabelOrderNewPage.vue?vue&type=script&lang=js"

import "./LabelOrderNewPage.vue?vue&type=style&index=0&id=5a0d5111&scoped=true&lang=css"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0d5111"]])

export default __exports__